/** PURE_IMPORTS_START .._.._Observable,.._.._operator_buffer PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { buffer } from '../../operator/buffer';
Observable.prototype.buffer = buffer;
//# sourceMappingURL=buffer.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/buffer.js
// module id = 643
// module chunks = 0